<div [formGroup]="formGroup" class="control control--input control--dropdown" [hidden]="hidden">
  <div *ngIf="model.hasLabel" class="control__header">
    <label class="control__header__label" [for]="model.key" [title]="model.label">{{ model.label }}</label>
    <div class="control__header__error" *ngIf="hasError" [title]="error">{{ error }}</div>
  </div>
  <p-dropdown
    #primeDropdown
    [hidden]="!hasOptions"
    appendTo="body"
    dropdownIcon="pi pi-caret-down"
    [styleClass]="classes"
    [readonly]="model.readonly"
    [filter]="model.filter"
    [options]="options"
    [placeholder]="model.placeholder"
    [name]="model.key"
    [inputId]="model.key"
    (onChange)="onChange.emit($event)"
    (onInput)="onInput.emit($event)"
    (onFocus)="onFocus.emit($event)"
    (onBlur)="onBlur.emit($event)"
    [formControlName]="model.key">
  </p-dropdown>
  <div *ngIf="!hasOptions" class="text--danger">Information Not Available.</div>
</div>